import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'

import Layout from 'components/PageLayout'
import SEO from 'components/SEO'
import Footer from 'components/Footer'
import Banner from 'components/Banner'

import ActivityList from './ActivityList'

export const ActivitiesPageTemplate = ({
  seo,
  header,
  onSiteActivities,
  offSiteActivities
}) => (
  <Fragment>
    <Banner
      sizes={header.image.childImageSharp.fluid}
      title={header.title}
      paragraph={header.paragraph}
    />
    <ActivityList
      title={onSiteActivities.title}
      subtitle={onSiteActivities.subtitle}
      activities={onSiteActivities.activities}
    />
    <ActivityList
      title={offSiteActivities.title}
      subtitle={offSiteActivities.subtitle}
      activities={offSiteActivities.activities}
    />
    <Footer />
  </Fragment>
)

export default ({ data }) => {
  const { frontmatter } = data.markdownRemark
  const { title, description } = frontmatter.seo
  return (
    <Layout>
      <SEO title={title} description={description} />
      <Helmet title={title} />
      <ActivitiesPageTemplate
        header={frontmatter.header}
        onSiteActivities={frontmatter.onSiteActivities}
        offSiteActivities={frontmatter.offSiteActivities}
      />
    </Layout>
  )
}

export const query = graphql`
  query ActivitiesPageQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        seo {
          title
          description
        }
        header {
          title
          paragraph
          image {
            childImageSharp {
              fluid(maxWidth: 2000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        onSiteActivities {
          title
          subtitle
          activities {
            name
            description
            images {
              image {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
        offSiteActivities {
          title
          subtitle
          activities {
            name
            description
            link
            images {
              image {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
